export default "__VITE_ASSET__CZ9wbdgG__"